import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import React from 'react';

const FocusButtons = ({
    focusKey,
    bgColor = "#1da1f2",
    text = "Done",
    onClick = () => { },
}) => {
    const { ref, focused } = useFocusable({
        focusKey: focusKey,
        isFocusBoundary: true,
        onEnterRelease: () => { onClick() },
    });
    return (
        <FocusContext.Provider value={focusKey} >
            <span ref={ref} style={{ backgroundColor: bgColor, color: "white", padding: "2px 7px", borderRadius: "5px", cursor: "pointer", fontSize: "16px", fontWeight: "normal", letterSpacing: "0", outline: focused ? "2px solid white" : "2px solid transparent", marginRight: "10px" }} onClick={onClick}>{text}</span>
        </FocusContext.Provider>
    );
}

export default FocusButtons;
